/**
 * Get correct payment failure error text
 * @param {Function} t - translation method
 * @param {object} payment - payment object
 * @returns {object}
 */
const paymentFailureText = (t, payment) => {
	if (/40016/.test(payment.failureCode)) { // '40016' - embargo countries
		return {
			headline: t('paymentFailed_title'),
			subHeadline: t('paymentFailed_error40016')
		};
	}
	return {
		headline: t('paymentFailed_title'),
		subHeadline: t('paymentFailed_subTitle')
	};
};

export default paymentFailureText;
